const StaticValetActivities = {
    "DIGITAL" : {
        "CAR_COLLECTION" : {
            name: "Car Collected",
            text: "Car Collected",
            subText: "Your vehicle is in good hands.",
            timestamp: "",
            currentlyOngoing: false
        },
        "PARKING_AND_IMAGE_CAPTURE" : {
            name: "Car Parked",
            timestamp: "",
            text: "Car Parked",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        },
        "VEHICLE_RECALL" : {
            name: "Car Recall",
            timestamp: "",
            text: "Car arriving soon",
            subText: "OTP sent to your mobile. Please verify with the operator.",
            currentlyOngoing: false
        },
        // "OTP_SENT" : {
        //     name: "OTP Sent",
        //     timestamp: "",
        //     text: "Car arriving soon",
        //     subText: "OTP sent to your mobile. Please verify with the operator.",
        //     currentlyOngoing: false
        // },
        "CAR_ARRIVED" : {
            name: "Car Arrived",
            timestamp: "",
            text: "Car Arrived",
            subText: "Your vehicle is arrived.",
            currentlyOngoing: false
        }, 
        "CAR_HANDOVER" : {
            name: "Car Handover",
            timestamp: "",
            text: "Car Handed Over",
            subText: " ",
            currentlyOngoing: false
        }
    },
    "NON-DIGITAL" : {
        "CAR_COLLECTION" : {
            name: "Car Collected",
            text: "Car Collected",
            subText: "Your vehicle is in good hands.",
            timestamp: "",
            currentlyOngoing: false
        },
        "PARKING_AND_IMAGE_CAPTURE" : {
            name: "Car Parked",
            timestamp: "",
            text: "Car Parked",
            subText: "Your vehicle is in good hands.",
            currentlyOngoing: false
        },
        "CAR_HANDOVER" : {
            name: "Car Handover",
            timestamp: "",
            text: "Car Handed Over",
            subText: " ",
            currentlyOngoing: false
        }
    },
}

const CAR_COLLECTION = "Car Collected"
const PARKING_AND_IMAGE_CAPTURE = "Car Parked"
const CAR_ARRIVED = "Car Arrived"
const CAR_HANDOVER = "Car Handover"
const VEHICLE_RECALL = "Car Recall" 
const OTP_SENT = "OTP Sent"

export {StaticValetActivities, CAR_ARRIVED, CAR_COLLECTION, CAR_HANDOVER, VEHICLE_RECALL, OTP_SENT, PARKING_AND_IMAGE_CAPTURE}